import type { OptimizationActionResponseModel } from '@/shared/generated'

export const getBulkImportResult = (
	responses: OptimizationActionResponseModel[]
) => {
	let og_total = 0
	let sku_total = 0
	for (const response of responses) {
		if (response.success) {
			og_total += 1
			sku_total += response.count || 0
		}
	}

	return {
		og_total,
		sku_total,
	}
}
